import { Box, Grid } from '@mui/material';
import { LAYOUT } from '../../../constants/layout';
import UpFrame from './UpFrame';
import CentralFrame from './CentralFrame';
import LogFrame from './LogFrame';

interface PageLayoutProps {
  title?: string;
  upFrameContent?: React.ReactNode;
  centralFrameContent: React.ReactNode;
  logFrameContent: React.ReactNode | null;
  showLogFrame?: boolean; // Controls whether log frame column is visible
  isLogFrameExpanded?: boolean; // Controls whether log frame takes full width
}

const PageLayout = ({ 
  title, 
  upFrameContent, 
  centralFrameContent, 
  logFrameContent,
  showLogFrame = true, // Default to showing log frame
  isLogFrameExpanded = false // Default to not expanded
}: PageLayoutProps) => {
  return (
    <Box sx={{ 
      height: `calc(100vh - ${LAYOUT.APP_BAR_HEIGHT}px)`,
      display: 'flex', 
      flexDirection: 'column', 
      gap: LAYOUT.GAP.MEDIUM / 8,
      p: LAYOUT.PADDING.MEDIUM / 8,
      mt: LAYOUT.CONTENT_GAP.APP_BAR / 8,
    }}>
      <UpFrame 
        title={title}
      >
        {upFrameContent}
      </UpFrame>

      <Grid container spacing={LAYOUT.GAP.MEDIUM / 8} sx={{ flexGrow: 1 }}>
        {/* When log frame is expanded, it takes the full width */}
        {isLogFrameExpanded && logFrameContent ? (
          <Grid item xs={12}>
            <LogFrame>
              {logFrameContent}
            </LogFrame>
          </Grid>
        ) : (
          <>
            {/* Normal layout: central frame and log frame side by side */}
            <Grid item xs={showLogFrame ? 8 : 12}>
              <CentralFrame>
                {centralFrameContent}
              </CentralFrame>
            </Grid>

            {/* Only render the log frame if showLogFrame is true and logFrameContent exists */}
            {showLogFrame && logFrameContent && (
              <Grid item xs={4}>
                <LogFrame>
                  {logFrameContent}
                </LogFrame>
              </Grid>
            )}
          </>
        )}
      </Grid>
    </Box>
  );
};

export default PageLayout; 